export const homeURL = "/";
export const aboutURL = "/about";
export const commingsoonURL = "/coming-soon";
export const thankYouURL = "/thank-you";
export const contactThankYouURL = "/contact-thank-you";
export const notFoundURL = "/404";
export const productsURL = "/our-products";
export const contactUsURL = "/contact-us";
export const privacyPolicyUrl = "/privacy-policy";
export const termsUrl = "/terms-conditions";
export const faqUrl = "/faqs";